import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Cookies from 'js-cookie';

const getDefaultCurrency = (appConfig) => {
  const cookieCurrency = Cookies.get('currency');
  if (!cookieCurrency) {
    // fallback if currency is not in cookies (most likely due to company did not setup currency)
    return (appConfig && appConfig.data && appConfig.data.currency) && appConfig.data.currency.symbol;
  }
  return cookieCurrency;
};

const CurrencySymbol = ({ appConfig }) => (
  <span>
    { getDefaultCurrency(appConfig) }
  </span>
);

CurrencySymbol.propTypes = {
  appConfig: PropTypes.shape({
    data: PropTypes.shape({
      currency: PropTypes.shape({
        code: PropTypes.string,
        symbol: PropTypes.string,
      }),
    }),
  }),
};

const mapStateToProps = state => ({
  appConfig: state.appConfig,
});

export default connect(mapStateToProps)(CurrencySymbol);



// WEBPACK FOOTER //
// ./src/components/CurrencySymbol.jsx